import Image from '@root/website-tooling/gatsby-image';
import LinkButton from '@root/joinroot.com/src/components/buttons/link-button';
import PropTypes from '@root/vendor/prop-types';
import Responsive from '@root/core/src/utils/responsive';
import { Eyebrow, H1Display, Subhead } from '@root/joinroot.com/src/components/text';
import { StyleSheet } from '@root/core/src/utils/styles';
import { TEXT_ALIGNMENT_OPTIONS } from '@root/joinroot.com/src/constants/constants';

export default function HeroImageFull({
  anchor,
  textAlignment = TEXT_ALIGNMENT_OPTIONS.CENTER,
  buttons,
  eyebrow,
  gatsbyImage,
  imageAlt,
  headline,
  styleProps,
  subhead,
  buttonComponent = LinkButton,
}) {
  const ButtonComponent = buttonComponent;

  return (
    <section
      css={[
        stylesBase.heroSection,
        textAlignment === TEXT_ALIGNMENT_OPTIONS.LEFT && stylesAlignmentLeft.heroSection,
        styleProps,
      ]}
      id={anchor}
    >
      <div className={'wrap_image'}>
        <Image
          alt={imageAlt}
          className={'bgImage'}
          fadeIn={false}
          fluid={gatsbyImage}
          loading={'eager'}
        />
      </div>
      <div className={'wrap_content'}>
        <div className={'container_content'}>
          {eyebrow && <Eyebrow className={'eyebrow'}>{eyebrow}</Eyebrow>}
          {headline && <H1Display className={'headline'}>{headline}</H1Display>}
          {subhead && <Subhead className={'subhead'}>{subhead}</Subhead>}
          {buttons && (
            <div className={'container_cta'}>
              {buttons.map((btn, i) => (
                <ButtonComponent
                  buttonStyles={buttonStyles}
                  key={i}
                  onClick={btn.onClick}
                  to={btn.link}
                  type={btn.type}
                >
                  {btn.text}
                </ButtonComponent>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

HeroImageFull.propTypes = {
  anchor: PropTypes.string,
  buttonComponent: PropTypes.func,
  buttons: PropTypes.arrayOf(PropTypes.object),
  eyebrow: PropTypes.string,
  gatsbyImage: PropTypes.object.isRequired,
  headline: PropTypes.string.isRequired,
  imageAlt: PropTypes.string,
  styleProps: PropTypes.object,
  subhead: PropTypes.string,
  textAlignment: PropTypes.oneOf(Object.values(TEXT_ALIGNMENT_OPTIONS)),
};

const stylesAlignmentLeft = StyleSheet.create({
  heroSection: {

    '.wrap_content .container_content': {
      ...Responsive.md({
        alignItems: 'flex-start',
        textAlign: 'left',

        '.container_cta': {
          ...Responsive.md({
            justifyContent: 'flex-start',
          }),
        },
      }),
    },
  },
});

const stylesBase = StyleSheet.create({
  heroSection: {
    position: 'relative',

    '.wrap_image': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: -1,

      '.bgImage': {
        height: '100%',
      },
    },

    '.wrap_content': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      minHeight: 'calc(100vh - 50px)',

      '.container_content': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        maxWidth: 1200,
        padding: 20,
        textAlign: 'center',

        ...Responsive.md({
          padding: '100px 20px',
        }),

        '.eyebrow': {
          maxWidth: 350,
        },

        '.headline, .subhead': {
          maxWidth: 550,

          ...Responsive.md({
            maxWidth: 800,
          }),
        },

        '.eyebrow, .headline, .subhead': {
          marginBottom: 12,
          color: 'white',
          textShadow: '0 0 10px hsla(0, 0%, 0%, 0.3)',
        },

        '.container_cta': {
          display: 'flex',
          flexDirection: 'column',
          margin: '30px -10px 0', // -10px accounts for margin on cta elements within.
          width: '100%',
          maxWidth: 260,

          ...Responsive.md({
            justifyContent: 'center',
            flexDirection: 'row',
            maxWidth: 480,
          }),
        },
      },
    },
  },
});

const buttonStyles = {
  margin: 10,
};
